import { render, staticRenderFns } from "./AboutTechTitleBlock.vue?vue&type=template&id=60fbab53"
import script from "./AboutTechTitleBlock.vue?vue&type=script&lang=js"
export * from "./AboutTechTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutTechTitleBlock.vue?vue&type=style&index=0&id=60fbab53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports